import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Dropdown, MenuProps } from 'antd';

import LogoutIcon from 'assets/images/menu/logout.svg?react';
import ProfileIcon from 'assets/images/menu/profile.svg?react';
import { useAppConfigRetrieveQuery } from 'shared/api';
import { EMainRoutes } from 'shared/typings';
import { Avatar } from 'shared/ui';
import { logoutKeycloak } from 'shared/utils';

interface IUserInfoProps extends HTMLAttributes<HTMLDivElement> {
	isPublisher?: boolean;
}

export const UserInfo: FC<IUserInfoProps> = ({ isPublisher }: IUserInfoProps) => {
	const { t } = useTranslation();

	const { data: appConfig } = useAppConfigRetrieveQuery();

	const advItems: MenuProps['items'] = [
		{
			key: '1',
			label: appConfig?.user?.email,
			disabled: true,
		},
		{
			key: '2',
			label: <Link to={`/${EMainRoutes.PROFILE}`}>{t('My profile')}</Link>,
			icon: <ProfileIcon />,
		},
		{
			type: 'divider',
		},
		{
			key: '3',
			label: <a onClick={() => logoutKeycloak()}>{t('Log out')}</a>,
			icon: <LogoutIcon />,
		},
	];

	const pubItems: MenuProps['items'] = [
		{
			key: '1',
			label: <Link to={`/${EMainRoutes.PROFILE}`}>{t('Account settings')}</Link>,
		},
		{
			key: '2',
			label: <Link to={`/${EMainRoutes.PUBLISHER}/${EMainRoutes.PORTFOLIO}/`}>{t('Portfolio')}</Link>,
		},
		{
			type: 'divider',
		},
		{
			key: '3',
			label: <a onClick={() => logoutKeycloak()}>{t('Log out of Account')}</a>,
		},
	];

	const items = isPublisher ? pubItems : advItems;
	return (
		<Dropdown menu={{ items }} trigger={['click']} arrow>
			<Avatar style={{ cursor: 'pointer' }} />
		</Dropdown>
	);
};
